import { mapGetters } from 'vuex'
import { parseISO, isDate } from 'date-fns'

import { STORE_MODULES } from '@/js/plugins/store/modules/aimeos/actions/std-imports'
import APP_GETTERS from '@/js/plugins/store/modules/app/getter-types.js'

export default {
  computed: {
    ...mapGetters(STORE_MODULES.APP, {
      isSmWidth: APP_GETTERS.IS_SM_WIDTH,
      companies: APP_GETTERS.USER_COMPANIES,
    }),
  },
  methods: {
    getBrandNameForCode(code) {
      return this.companies?.find(comp => comp.id === code?.toString())?.name ?? ''
    },
    stripAndTrimBlockingreasonTranslation(translationCode, stringLength = 120) {
      const rawString = this.$t(`account.blockingreasons.reasons.${translationCode}`)
      const strippedString = rawString?.replace(/(<([^>]+)>)/gi, '')
      const trimmedTranslation = strippedString.substring(0, stringLength) + '...'

      return trimmedTranslation
    },
    formatDate(value, format = 'dateFormat') {
      if (!value) {
        return '-'
      }

      const parsedDate = parseISO(value)

      if (!parsedDate || !isDate(parsedDate)) {
        return '-'
      }

      // Catch weird date formats from backorder api
      try {
        const date = format ? this.$d(parsedDate, format) : this.$d(parsedDate)
        return date
      } catch {
        return '-'
      }
    },
  },
}
